import { Button, Group, Modal } from "@mantine/core";
import { IconAlertTriangleFilled } from "@tabler/icons-react";
import { ModalFooter } from "../../../../mantine/components/ModalFooter/ModalFooter";
import "./MetersSaveWarningModal.scss";

interface MetersSaveConfirmModalProps {
  isOpen: boolean;
  onCloseEditModal: () => void;
  onCloseSelectedMetersWarningModal: () => void;
}

function MetersSaveWarningModal({
  isOpen,
  onCloseEditModal,
  onCloseSelectedMetersWarningModal
}: MetersSaveConfirmModalProps) {
  return (
    <Modal
      opened={isOpen}
      title={
        <Group gap="sm">
          <IconAlertTriangleFilled
            color="var(--mantine-color-warning-filled)"
            size={16}
          />
          Sie haben ungespeicherte Änderungen!
        </Group>
      }
      onClose={onCloseSelectedMetersWarningModal}
    >
      <div className="MeterSaveWarningDescription">
        <p>
          Sie haben nicht gespeicherte Änderungen für Zähler, die beim Schließen
          verloren gehen würden.
        </p>
        <p>Sind Sie sicher, dass Sie das Fenster schließen wollen?</p>
      </div>
      <ModalFooter>
        <Button variant="default" onClick={onCloseSelectedMetersWarningModal}>
          Abbrechen
        </Button>
        <Button
          color="warning"
          onClick={() => {
            onCloseSelectedMetersWarningModal();
            onCloseEditModal();
          }}
        >
          Ja, schließen
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export { MetersSaveWarningModal };
